import React from "react";
import {
  FaBalanceScale,
  FaEquals,
  FaProjectDiagram,
  FaWaveSquare,
} from "react-icons/fa";

function ConstantProductAMM() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Types of AMM Models We Develop at Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaBalanceScale size={45} color="#2f6edb" />
                  </div>
                  <h4>Constant Product AMM</h4>
                  <p>
                    Designed for simplicity and reliability, this model uses the
                    formula x×y=kx \times y = kx×y=k to provide balanced
                    pricing, suitable for most token pairs.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaEquals size={45} color="#2f6edb" />
                  </div>
                  <h4>Constant Sum AMM</h4>
                  <p>
                    Ideal for stablecoin trading, this model uses a constant sum
                    formula to minimize slippage on stable pairs, creating a
                    more stable trading environment for similar assets.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaProjectDiagram size={45} color="#2f6edb" />
                  </div>
                  <h4>Hybrid AMM Models</h4>
                  <p>
                    For platforms seeking to provide diversified trading
                    options, we develop hybrid AMMs that combine different AMM
                    formulas, such as Constant Product and Constant Sum, to
                    support both volatile assets and stablecoins.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaWaveSquare size={45} color="#2f6edb" />
                  </div>
                  <h4>Dynamic AMMs</h4>
                  <p>
                    Advanced models that adjust fees and slippage based on
                    market conditions, providing users with a responsive trading
                    experience that optimizes liquidity management.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConstantProductAMM;
